import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import NotFound from "./pages/NotFound";
import Contratar from "./pages/Contratar";
import ContratacaoFluxoPreview from "./pages/ContratacaoFluxoPreview";
import Sucesso from "./pages/Sucesso";
import Erro from "./pages/Erro";
import AuthHandoff from "./pages/AuthHandoff";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/demo/contratacao" replace />} />
            <Route path="/admin/*" element={<Navigate to="/demo/contratacao" replace />} />
            <Route path="/login" element={<Navigate to="/demo/contratacao" replace />} />
            <Route path="/contratar/:slug" element={<Contratar />} />
            <Route path="/demo/contratacao" element={<ContratacaoFluxoPreview />} />
            <Route path="/auth/handoff" element={<AuthHandoff />} />
            <Route path="/sucesso" element={<Sucesso />} />
            <Route path="/erro" element={<Erro />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
